import api, { API } from "./api";
import { fileToCompressedBlob } from "./imageUtils";

// Compress locally, upload to the backend, return an absolute public image URL.
export async function uploadImageFile(file, maxEdge = 2400, quality = 0.85) {
    const blob = await fileToCompressedBlob(file, maxEdge, quality);
    const form = new FormData();
    form.append("file", blob, "upload.jpg");
    const { data } = await api.post("/admin/uploads/image", form);
    const origin = API.replace(/\/api$/, "");
    return `${origin}${data.path}`;
}
